import create from 'zustand';
import { BasketUIState, MiniBasketStoreSuggestionStatus } from '../models';

type UseBasketState = BasketUIState & {
    setAddedProductId: (state: string) => void;
    addedProductId: string;
};

export const useBasketState = create<UseBasketState>((set) => ({
    isMiniBasketOpen: false,
    miniBasketStoreSuggestionName: null,
    miniBasketStoreSuggestionError: null,
    miniBasketStoreSuggestionStatus: MiniBasketStoreSuggestionStatus.IDLE,
    toggleMiniBasket: (open) => {
        set(() => ({
            isMiniBasketOpen: open,
        }));
    },
    setAddedProductId: (state) => {
        set(() => ({
            addedProductId: state,
        }));
    },
    setMiniBasketStoreSuggestionName: (storeName) => {
        set(() => ({
            miniBasketStoreSuggestionName: storeName,
        }));
    },
    setMiniBasketStoreSuggestionError: (message) => {
        set(() => ({
            miniBasketStoreSuggestionError: message,
        }));
    },
    setMiniBasketStoreSuggestionStatus: (status) => {
        set(() => ({
            miniBasketStoreSuggestionStatus: status,
        }));
    },
    addedProductId: '',
}));
